export const types = {
    TRUCK_ID_CONTENT : "TRUCK_ID_CONTENT",
}